<template><div class="alert-detail" @click.stop>
  <button @click="$emit('input', null)">
    Hide details
    <span class="material-icons">close</span>
  </button>
  <div v-if="detail" class="offsets">
    <button v-for="(label,i) in indices"
      @click="index=i"
      :class="{selected:index===i}"
      v-html="label"
      :key="i"
      />
  </div>
  <div class="alert-text" ref="scroll" @scroll="scroll">
    <Loading v-if="ref" />
    <div v-else-if="error">
      An error occurred.
      <button @click="refresh">Try again</button>
    </div>
    <div v-else-if="detail">
      <pre v-html="detail.screens[index][0]" />
      <hr />
      <pre v-html="detail.screens[index][1]" />
    </div>
    <span v-else-if="value">There are no details to display.</span>
  </div>
</div></template>
<script>
import api from '../../api'
import Loading from '../Loading'
export default {
  name: 'alert-detail',
  props: ['value'],
  emits: ['input'],
  components: { Loading },
  data() {
    return {
      ref: null,
      detail: null,
      error: null,
      index: 7,
      indices: [
        '-2.5s',
        '-2.0s',
        '-1.5s',
        '-1.0s',
        '-0.5s',
        '-0.2s',
        '-0.1s',
        '0s',
        '+0.1s',
        '+0.5s',
      ],
    }
  },
  created() { this.refresh() },
  watch: {
    id() {
      this.refresh()
    },
  },
  methods: {
    scroll(e) {
      global.alertDetailScroll = [ e.target.scrollLeft, e.target.scrollTop ]
    },
    async refresh() {
      if (this.ref) {
        const oldRef = this.ref
        this.ref = null
        oldRef.cancel()
      }
      this.detail = null
      this.error = null
      const ref = this.ref = { id: this.value }
      try {
        this.index = 7
        this.detail = await api.getAlertDetails(ref)
        this.ref = null
        this.$nextTick(() => {
          if (global.alertDetailScroll) {
            const el = this.$refs.scroll,
              [ x, y ] = global.alertDetailScroll
            console.log(x, y, el)
            el.scrollLeft = x
            el.scrollTop = y
          }
        })
      } catch(e) {
        if (this.ref === ref) {
          this.ref = null
          this.error = true
          console.error(e)
        }
      }

    },
  },
}
</script>
<style lang="scss">
.alert-detail {
  margin-top: 5px;
  border-top: 1px solid #000;
  > button {
    margin: 5px 0;
    line-height: 22px;
    .material-icons {
      vertical-align: bottom;
    }
  }
  .offsets {
    display: flex;
    justify-content: center;
    gap: 5px;
    button.selected { background: #afa; }
    margin-bottom: 5px;
  }
  .alert-text {
    overflow-x: auto;
    overflow-y: scroll;
    min-height: 100px;
    max-height: 300px;
    padding: 0 10px;
    border: 3px double #000;
    background-color: #fff;
  }
}
</style>
